export const EVENT_FORM_CONTEXT_IS_IDENTITY_DOCUMENT_REQUIRED =
  'isIdentityDocumentRequired'

export const EVENT_FORM_CONTEXT_IDENTITY_DOCUMENT_EXEMPT_ATTENDEE_IDS =
  'identityDocumentExemptAttendeeIds'

export const EVENT_FORM_CONTEXT_IS_DOCUMENT_NUMBER_REQUIRED =
  'isDocumentNumberRequired'

export const EVENT_FORM_CONTEXT_IS_WITNESS_LOCATION_REQUIRED =
  'isWitnessLocationRequired'

export const EVENT_FORM_CONTEXT_IS_ZOOM_PARTICIPANTS_MAPPING_REQUIRED =
  'isZoomParticipantsMappingRequired'

export const EVENT_FORM_CONTEXT_CAN_WITNESS_READ_OR_WAIVE =
  'canWitnessReadOrWaive'

export const EVENT_FORM_CONTEXT_ERRATA_APPLIES = 'errataApplies'

export const EVENT_FORM_CONTEXT_ERRATA_RECIPIENT_ATTENDEE_ID =
  'errataRecipientAttendeeId'

export const EVENT_FORM_CONTEXT_IS_EUO = 'isEUO'

export const EVENT_FORM_CONTEXT_IS_FINAL_SCRIPT_EVENT = 'isFinalScriptEvent'
